import InsufficientMaterials from "./InsufficientMaterials";
import PotentialLostCustomers from "./PotentialLostCustomers";
import TieredCustomerPerformance from "./TieredCustomerPerformance";
import NonTieredCustomerPerformance from "./NonTieredCustomerPerformance";
import InventoryOver90 from "./InventoryOver90";
import AROver90 from "./AROver90";
import EstimatingTurnaround from "./EstimatingTurnaround";
import EstimateReady from "./EstimateReady";
import NewCustomersSecured from "./NewCustomersSecured";
import RevenueProfit from "./RevenueProfit";
import WrittenSales from "./WrittenSales";
import OrderDeskCalls from "./OrderDeskCalls";
import NotShippedInvoices from "./NotShippedInvoices";
import UnshippedJobs from "./UnshippedJobs";
import NonShippedLabor from "./NonShippedLabor";
import SalesInventoryView from "./SalesInventoryView";
import ReceivingTime from "./ReceivingTime";
import RsoSalesForecast from "./RsoSalesForecast";

// Single source of truth for dashboard widgets.
//
// - The Role admin modal's "Dashboard" section renders one checkbox per entry
//   (using `id` + `label`).
// - Dashboard.jsx maps a role's selected widget `id`s to the `component` to render.
//
// To add a new widget: build its component in this folder and add an entry here.
// Nothing else needs to change — it will automatically appear as a configurable
// checkbox in the Role modal and render on the dashboards that select it.
//
// The previous dashboard's stat cards / Job Alerts / Bank Balance / Cash Collected
// Today were placeholders and were dropped; real widgets are built here as designed.
export const WIDGET_REGISTRY = [
  {
    id: "potential-lost-customers",
    label: "Potential Lost Customers",
    component: PotentialLostCustomers,
  },
  {
    id: "tiered-customer-performance",
    label: "Tiered Customer Performance",
    component: TieredCustomerPerformance,
  },
  {
    id: "non-tiered-customer-performance",
    label: "Non Tiered Customer Performance",
    component: NonTieredCustomerPerformance,
  },
  {
    id: "new-customers-secured",
    label: "New Customers Secured",
    component: NewCustomersSecured,
  },
  {
    id: "revenue-profit",
    label: "Revenue & Profit",
    component: RevenueProfit,
  },
  {
    id: "written-sales",
    label: "Written Sales",
    component: WrittenSales,
  },
  {
    id: "estimating-turnaround",
    label: "Estimating Turnaround",
    component: EstimatingTurnaround,
  },
  {
    id: "estimate-ready",
    label: "Estimate Ready",
    component: EstimateReady,
  },
  {
    id: "order-desk-missed-calls",
    label: "Order Desk Missed Calls",
    component: OrderDeskCalls,
  },
  {
    id: "inventory-over-90",
    label: "Inventory Over 90",
    component: InventoryOver90,
  },
  {
    id: "ar-over-90",
    label: "A/R Over 90",
    component: AROver90,
  },
  {
    id: "insufficient-materials",
    label: "Insufficient Materials",
    component: InsufficientMaterials,
  },
  {
    id: "not-shipped-invoices",
    label: "Not Invoiced",
    component: NotShippedInvoices,
  },
  {
    id: "unshipped-jobs",
    label: "Unshipped Jobs",
    component: UnshippedJobs,
  },
  {
    id: "non-shipped-labor",
    label: "Non Shipped Labor",
    component: NonShippedLabor,
  },
  {
    id: "sales-inventory-view",
    label: "Sales Inventory View",
    component: SalesInventoryView,
  },
  {
    id: "receiving-time",
    label: "Receiving Time",
    component: ReceivingTime,
  },
  {
    id: "sales-rso-forecast",
    label: "RSO Forecast",
    component: RsoSalesForecast,
  },
];

// Convenience lookup: { [id]: component }
export const WIDGET_COMPONENTS = WIDGET_REGISTRY.reduce((acc, w) => {
  acc[w.id] = w.component;
  return acc;
}, {});

// All known widget ids (used as the backward-compatible default when a role
// has no dashboard config yet).
export const ALL_WIDGET_IDS = WIDGET_REGISTRY.map((w) => w.id);
